import { Link, useLocation } from "react-router-dom";
import { Home, Search, Camera, MessageCircle } from "lucide-react";

const navItems = [
  { path: "/dashboard", icon: Home },
  { path: "/meal-analysis", icon: Search },
  { path: "/meal-journal", icon: Camera },
  { path: "/chat", icon: MessageCircle },
];

export const BottomNav = () => {
  const location = useLocation();

  return (
    <nav className="fixed bottom-6 left-4 right-4 bg-secondary/90 backdrop-blur-lg text-white rounded-full px-3 py-2.5 flex justify-around items-center shadow-2xl z-50 max-w-sm mx-auto" data-testid="bottom-nav">
      {navItems.map(({ path, icon: Icon }) => {
        const isActive = location.pathname === path;
        return (
          <Link
            key={path}
            to={path}
            className={`p-2 rounded-full transition-colors ${
              isActive ? "text-white bg-white/20" : "text-white/50 hover:text-white/80"
            }`}
            data-testid={`nav-${path.slice(1) || "home"}`}
          >
            <Icon className="w-5 h-5" />
          </Link>
        );
      })}
    </nav>
  );
};
